// @flow

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import grey from '@material-ui/core/colors/grey';
import Icon from '@material-ui/core/Icon';
import { I18n } from 'react-redux-i18n';

const styleSheet = theme => ({
  chip: {
    margin: theme.spacing.unit
  },
  truncateChip: {
    maxWidth: '195px',
    overflow: 'hidden',
    margin: theme.spacing.unit
  },
  svgIcon: {
    color: grey[800]
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  }
});

class Chips extends Component {
  getIcon = type => {
    switch (type) {
      case 'mediaId':
        return 'play_circle_outline';
      case 'driver':
        return 'person';
      case 'vehicle':
        return 'local_shipping';
      case 'dvr':
        return 'dvr';
      default:
        return '';
    }
  }

  render() {
    const {
      classes,
      list,
      onRemove,
      hideIcon,
      hideDelete,
      showClearAll,
      handleClearAllFilter,
      ...other
    } = this.props;

    return (
      <div className={`${classes.row} chipContainer`}>
        {
          list && list.map((chip, index) => (
            <Chip
              key={index}
              avatar={
                <Avatar className="chip" style={{display: chip.hideIcon ? 'none' : 'flex'}}>
                  <Icon className="chip__icon">{this.getIcon(chip.name)}</Icon>
                </Avatar>
              }
              label={chip.label}
              title={chip.label}
              onDelete={chip.hideDelete ? null : event => onRemove(event, chip)}
              className={this.props.truncateLabel ? `${classes.truncateChip} truncateText ml-0` : classes.chip}
              {...other}
            />))
        }
        {this.props.showClearAll ? <a className="clearChips" onClick={this.props.handleClearAllFilter}>{I18n.t('filter.clearAll')}</a> : '' }
      </div>
    );
  }
}

Chips.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

export default withStyles(styleSheet)(Chips);
